function request(reflexId, target, args, controller, element, controllerElement) {
  reflexes[reflexId].timestamp = new Date();
  console.log("\u2191 stimulus \u2191 ".concat(target), {
    reflexId,
    args,
    controller,
    element,
    controllerElement
  });
}

function success(event) {
  const _ref = event || {},
        detail = _ref.detail;

  const _ref2 = detail || {},
        selector = _ref2.selector;

  const _ref3 = detail.stimulusReflex || {},
        reflexId = _ref3.reflexId,
        target = _ref3.target,
        morph = _ref3.morph,
        serverMessage = _ref3.serverMessage;

  const reflex = reflexes[reflexId];
  const progress = reflex.totalOperations > 1 ? " ".concat(reflex.completedOperations, "/").concat(reflex.totalOperations) : '';
  const duration = reflex.timestamp ? "in ".concat(new Date() - reflex.timestamp, "ms") : 'CLONED';
  const operation = event.type.split(':')[1].split('-').slice(1).join('_');
  const halted = serverMessage && serverMessage.subject === 'halted' || false;
  console.log("\u2193 reflex \u2193 ".concat(target, " \u2192 ").concat(selector || '\u221E').concat(progress, " ").concat(duration), {
    reflexId,
    morph,
    operation,
    halted
  });
}

function error(event) {
  const _ref4 = event || {},
        detail = _ref4.detail;

  const _ref5 = detail.stimulusReflex || {},
        reflexId = _ref5.reflexId,
        target = _ref5.target,
        serverMessage = _ref5.serverMessage;

  const reflex = reflexes[reflexId];
  const duration = reflex.timestamp ? "in ".concat(new Date() - reflex.timestamp, "ms") : 'CLONED';
  const payload = detail.stimulusReflex;
  console.log("\u2193 reflex \u2193 ".concat(target, " ").concat(duration, " %cERROR: ").concat(serverMessage.body), 'color: #f00;', {
    reflexId,
    payload
  });
}

export default {
  request,
  success,
  error
};